export const DEFAULT_PRODUCT_IMAGE = 'https://placehold.co/250x250/transparent/1E293B?text=Producto+Sin+Foto';

/**
 * Retorna la URL de la imagen del producto o el placeholder por defecto si no existe.
 * @param {string|null|undefined} url
 * @returns {string}
 */
export const getProductImageUrl = (url) => {
  if (!url || typeof url !== 'string' || url.trim() === '') {
    return DEFAULT_PRODUCT_IMAGE;
  }
  return url;
};

/**
 * Mapeo de colores para los ítems / productos individuales (SaleOrderItem)
 * Estatus:
 * 1: Entregado en Venta / Caja
 * 2: Pendiente por surtir
 * 3: En Tránsito
 * 4: Listo para Entrega
 * 5: Entregado en Recolección
 */
export const getItemStatusColor = (statusId) => {
  const map = {
    1: 'grey darken-1', // Entregado en Venta
    2: 'error', // Pendiente
    3: 'info', // En Tránsito
    4: 'orange darken-2', // Listo para Entrega (o 'lightPrimary' / 'warning darken-1')
    5: 'success', // Entregado en Recolección
  };
  return map[statusId] || 'grey lighten-1';
};

/**
 * Mapeo de colores para el Estatus Macro / General de la Venta (SaleOrder)
 * Estatus:
 * 1: Pendiente Completo
 * 2: Surtido Parcial
 * 3: Entregado Total
 * 4: Listo para Entrega
 */
export const getOverallStatusColor = (statusId) => {
  const map = {
    1: 'error', // Pendiente Completo
    2: 'orange darken-2', // Surtido Parcial
    3: 'success', // Entregado Total
    4: 'orange darken-2', // Listo para Entrega
  };
  return map[statusId] || 'grey lighten-1';
};
